import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "justify-content-center d-flex flex-center"
}
const _hoisted_2 = {
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_3 = { class: "sr-only" }

import {ref, onBeforeMount, computed} from "vue";
import { useStore } from "vuex";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ChallengeCard from "@/components/challenges/ChallengeCard.vue";
import {useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
// import ChallengeActivity from "@/components/challenges/ChallengeActivity.vue";
import ChallengeActivityModern from "@/modern/components/challenges/ChallengeActivity.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const {t} = useI18n()
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));


const store = useStore();
const router = useRouter();
const loading = ref(false)


const challenge = computed(() => store.getters.getChallenges);
onBeforeMount(async ()=>{
  loading.value = true
  await store.commit(Mutations.SET_CURRENT_MACHINE, {});
  await store.dispatch(Actions.GET_CHALLENGE, props.id).then((data) => {});
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "...", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(challenge) && !loading.value)
      ? (_openBlock(), _createBlock(ChallengeCard, {
          key: 1,
          challenge: _unref(challenge),
          type: "training"
        }, null, 8, ["challenge"]))
      : _createCommentVNode("", true),
    (_unref(challenge) && !loading.value)
      ? (_openBlock(), _createBlock(ChallengeActivityModern, {
          key: 2,
          challenge: _unref(challenge)
        }, null, 8, ["challenge"]))
      : _createCommentVNode("", true)
  ]))
}
}

})